/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
export const SHOWCASE_SHOTS = [
  {
    id: "dashboard",
    src: "/showcase/dashboard.jpeg",
    titleAr: "لوحة التحكم",
    titleEn: "Dashboard",
    descAr: "نظرة شاملة على المبيعات والأرباح والزيارات في مكان واحد.",
    descEn: "A clear overview of sales, profits, and visits in one place.",
  },
  {
    id: "orders",
    src: "/showcase/order.jpeg",
    titleAr: "إدارة الطلبات",
    titleEn: "Orders",
    descAr: "تتبّع حالة كل طلب من الإنشاء حتى التسليم بسهولة.",
    descEn: "Track every order from creation to delivery with ease.",
  },
  {
    id: "products",
    src: "/showcase/product.jpeg",
    titleAr: "المنتجات والمخزون",
    titleEn: "Products",
    descAr: "أضف منتجاتك، راقب المخزون، وحدّث الأسعار بخطوات بسيطة.",
    descEn: "Add products, monitor stock, and update prices in simple steps.",
  },
  {
    id: "profit",
    src: "/showcase/profit.jpeg",
    titleAr: "تقارير الأرباح",
    titleEn: "Profit Reports",
    descAr: "حلّل مبيعاتك وتكاليفك وصافي ربحك بتقارير واضحة.",
    descEn: "Analyze sales, costs, and net profit with clear reports.",
  },
  {
    id: "overview",
    src: "/showcase/last.jpeg",
    titleAr: "تحليل الطلبات",
    titleEn: "Order Insights",
    descAr: "وزّع الطلبات حسب المحافظات وتابع أحدث العمليات فورًا.",
    descEn: "See order distribution by region and latest activity instantly.",
  },
];
